<template>
  <div class="card store-card">
    <card-image
      :imageURL="
        locale === 'en' && store.storeInfo.imageURL.endsWith('em-breve.png')
          ? 'https://s3.amazonaws.com/assets.onii.com.br/stores/coming-soon.png'
          : store.storeInfo.imageURL
      "
    />

    <div class="card-content">
      <store-title
        :type="store.storeInfo.type"
        :name="store.storeInfo.name"
        :vendingsOnly="store.storeInfo.vendingsOnly"
      />

      <div
        @click="copyContent(store._id, $t('common.copyStoreId'))"
        class="store-id"
      >
        <b>{{ `${$t("dashboard.storeId")}:` }}</b>
        {{ store._id }}
        <b-icon icon="copy"></b-icon>
      </div>

      <status-tag
        :status="store.storeInfo.status"
        :vendingsOnly="store.storeInfo.vendingsOnly"
      />

      <cashback-tag
        v-if="activeCashbacks.length > 0 && !store.storeInfo.vendingsOnly"
        :cashbacks="activeCashbacks"
        @open-cashback-modal="openCashbackModal"
      />

      <coupon-tag
        v-if="activeCoupons.length > 0 && !store.storeInfo.vendingsOnly"
        :coupons="activeCoupons"
        @open-coupon-modal="openCouponModal"
      />

      <promotion-cashback-tag
        v-if="
          store.promotionsCashbacks &&
            store.promotionsCashbacks.length &&
            !store.storeInfo.vendingsOnly
        "
        :cashbacks="store.promotionsCashbacks"
        @open-promotion-cashback-modal="openPromotionCashbackModal"
      />

      <div
        class="has-text-centered configs-div"
        v-if="permissions.seeStoreConfigs"
      >
        <button class="button is-outlined" @click="storeConfigs">
          <b-icon icon="cog"></b-icon>
          &nbsp;&nbsp;&nbsp;{{ $t("dashboard.config") }}
        </button>
      </div>

      <div
        class="has-text-centered configs-div"
        v-if="
          permissions.seeRefillsAndInventories && !store.storeInfo.vendingsOnly
        "
      >
        <button class="button is-outlined" @click="inventoriesAndRefills">
          <b-icon icon="clipboard"></b-icon>
          &nbsp;&nbsp;&nbsp;{{ $t("dashboard.inventoriesAndRefills") }}
        </button>
      </div>

      <store-stats :store="store" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import cardImage from "./store-card/CardImage";
import storeTitle from "./store-card/StoreTitle";
import statusTag from "./store-card/StatusTag";
import cashbackTag from "./store-card/CashbackTag";
import couponTag from "./store-card/CouponTag";
import promotionCashbackTag from "./store-card/PromotionCashbackTag";
import storeStats from "./store-card/StoreStats";

export default {
  props: ["store"],

  mixins: [common],

  components: {
    cardImage,
    storeTitle,
    statusTag,
    cashbackTag,
    couponTag,
    promotionCashbackTag,
    storeStats
  },

  methods: {
    storeConfigs() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/configs");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    inventoriesAndRefills() {
      this.$store
        .dispatch("setStoreBeingManaged", this.store)
        .then(() => {
          this.$router.push("/inventories-refills");
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        });
    },

    openCashbackModal() {
      this.$emit("open-cashback-modal", this.activeCashbacks);
    },

    openCouponModal() {
      this.$emit("open-coupon-modal", this.activeCoupons);
    },

    openPromotionCashbackModal() {
      this.$emit("open-cashback-modal", this.store.promotionsCashbacks);
    }
  },

  computed: {
    ...mapGetters(["permissions", "locale"]),

    activeCashbacks() {
      if (!this.store.cashbacks) return [];

      return this.store.cashbacks.filter(c => {
        return (
          c.isActive &&
          new Date().getTime() > new Date(c.beginDate).getTime() &&
          new Date().getTime() < new Date(c.endDate).getTime()
        );
      });
    },

    activeCoupons() {
      if (!this.store.coupons) return [];

      return this.store.coupons.filter(c => {
        return (
          c.isActive &&
          new Date().getTime() > new Date(c.beginDate).getTime() &&
          new Date().getTime() < new Date(c.endDate).getTime()
        );
      });
    }
  }
};
</script>

<style scoped>
.store-card {
  margin-bottom: 2rem;
}
.card-content {
  padding: 0.7rem;
}
.configs-div {
  margin-top: 1.5rem;
}
.store-id {
  text-align: center;
  margin-bottom: 1rem;
}
</style>
